<template>
  <div
    ref="sidemenu"
    class="flex fixed top-0 z-40 transform transition-all dark:border-r dark:border-white/10"
    :class="sideMenuMobileClass"
    @keydown="checkTabBack"
  >
    <div
      id="sideBarScoll"
      :class="collapsibleClasses"
    >
      <section>
        <router-link to="/" @click="CLOSE_MOBILEMENU" class="sidebar-mobile-greeting">
          Hello, {{ employeeFirstName }}
        </router-link>
        <div>
          <div v-for="section in btnSections" :key="section.name" class="focus:ring focus:border-blue-300" tabindex="-1">
            <div v-if="checkModulePermissions(section.module)" class="focus:ring focus:border-blue-300" tabindex="-1">
              <SideMenuButton :section="section" :btn-text="section.name" :btn-icon="section.icon" :is-single-page="section.isSinglePage" />
            </div>
          </div>
          <div v-if="showOrganizationLine">
            <div class="sidebar-divider">
              <h3 id="tenant-headline" class="sidebar-divider__label">
                {{ mainMenuCollapsed ? '' : 'ORGANIZATION' }}
              </h3>
            </div>
          </div>
          <div v-for="section in organizationBtnSections" :key="section.name">
            <div v-if="checkModulePermissions(section.module)">
              <SideMenuButton :section="section" :btn-text="section.name" :btn-icon="section.icon" :is-single-page="section.isSinglePage" />
            </div>
          </div>
        </div>
      </section>
      <!-- COLLAPSE / VERSION -->
      <div class="sidebar-footer">
        <a v-if="!mainMenuCollapsed || !screen.lg" @click.prevent="routeToReleasesPage" class="sidebar-footer__version">
          {{ version }}
        </a>
        <button
          v-if="screen.lg"
          @click="collapse"
          class="sidebar-footer__collapse"
        >
          <font-awesome-icon :icon="['fas', mainMenuCollapsed ? 'chevron-right' : 'chevron-left']" class="sidebar-footer__collapse-icon" />
        </button>
      </div>
    </div>
    <button
      v-show="mobileSideMenuOpen"
      id="closeSidemenuBtn"
      class="flex justify-center mt-2 ml-8 w-10 h-10 hover:bg-gray-50 dark:bg-navy-600 dark:hover:bg-gray-500/60 hover:bg-opacity-50 focus:bg-gray-50 focus:bg-opacity-100 rounded lg:m-0 lg:w-0 focus:outline-none"
      @click="CLOSE_MOBILEMENU()"
    >
      <font-awesome-icon :icon="['far', 'xmark']" class="text-white w-10 h-10 absolute lg:hidden" />
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import SideMenuButton from './SideMenuButton.vue'
import { currentVersion } from "../../../releases.js"

export default {
  name: "SideMenu",
  components: {
    SideMenuButton
  },
  data() {
    return {
      version: currentVersion,
      btnSections: [
        {
          name: "Site Track",
          icon: 'fak fa-site-track-icon',
          isSinglePage: false,
          userPermissions: [],
          module: "site_track",
        },
        {
          name: "Site Command",
          icon: 'fak fa-site-command-icon',
          isSinglePage: false,
          userPermissions: [],
          module: "site_command",
        },
        {
          name: "Site Scan",
          icon: 'fak fa-site-scan-icon',
          userPermissions: [],
          module: "site_scan",
          isSinglePage: false
        },
        {
          name: "Site Unite",
          icon: 'fak fa-site-unite-icon',
          userPermissions: [],
          module: "site_unite",
          isSinglePage: false
        },
        {
          name: "Alerts",
          icon: 'fak fa-alerts-icon',
          userPermissions: ["manager"],
          isSinglePage: true,
          module: "alerts",
        },
      ],
      organizationBtnSections: [
        {
          name: "Reports",
          icon: 'fak fa-reports-1-icon',
          userPermissions: ["manager"],
          isSinglePage: false,
          module: "reports",
        },
        {
          name: "Configuration",
          icon: 'fa-solid fa-gears',
          userPermissions: ["manager"],
          module: "configuration",
          isSinglePage: false,
        },
        {
          name: "Administration",
          icon: 'fa-solid fa-shield-keyhole',
          userPermissions: [],
          module: "administration",
          isSinglePage: false,
        },
      ],
      isMounted: false,
      tabBack: false
    }
  },
  computed: {
    ...mapState(["screen", "orientation"]),
    ...mapGetters([
      "mobileSideMenuOpen",
      "mainMenuCollapsed",
      "sectionMenuCollapsed",
      "modalOpen",
      "getActiveSite",
      "getPromptText",
      "getFullName",
      "getIsTenantSuperuser",
      "getPermissionSet",
      "getPOSSystem",
      "getAvailableModules",
      "mobileSubMenuOpen"
    ]),
    employeeFirstName() {
      return this.getFullName.split(" ")[0]
    },
    sideMenuMobileClass() {
      let classes = "lg:top-12 lg:transform-none "
      classes += (this.screen.lg) ? "h-sidemenu " : "h-full "
      classes += this.mainMenuCollapsed ? "lg:w-16 " : "lg:w-52 "
      if (!this.screen.lg) {
        classes += this.mobileSideMenuOpen
          ? "w-full bg-black bg-opacity-70 overflow-y-scroll "
          : "-translate-x-full "
      }
      if (this.mobileSideMenuOpen && this.screen.lg) classes += "lg:w-auto lg:bg-opacity-0 "
      return classes
    },
    collapsibleClasses() {
      let classes = "flex flex-col justify-between bg-gradient-to-b from-secondary via-secondary to-secondary-600 h-full w-4/5 sm:w-3/5 lg:overflow-y-auto hide-scrollBar "
      if (this.isMounted) classes += "transition-all " 
      classes += this.mobileSubMenuOpen ? "overflow-y-hidden " : "overflow-y-auto "
      classes += this.mainMenuCollapsed ? "lg:w-16 " : "lg:w-52 "
      return classes
    },
    showOrganizationLine() {
      return this.btnSections.some(x => this.getAvailableModules.includes(x.module))
        && this.organizationBtnSections.some(x => this.getAvailableModules.includes(x.module))
    },
    hasOpenModal() {
      return this.modalOpen
    },
    route() {
      return this.$route
    },
  },
  watch: {
    hasOpenModal(val) {
      if (val && this.mobileSideMenuOpen) {
        this.CLOSE_MOBILEMENU()
      }
    },
    getPromptText(val) {
      if (val !== null && this.mobileSideMenuOpen) {
        this.CLOSE_MOBILEMENU()
      }
    }
  },
  mounted() {
    this.$router.isReady()
    .then(() => { 
      if (this.$route.path.substring(1).includes("/") && !this.mainMenuCollapsed) this.collapse()
      setTimeout(() => this.isMounted = true, 1000)
    })
    document.addEventListener("focusin", this.handleTab, true)
  },
  beforeUnmount() {
    document.removeEventListener("focusin", this.handleTab, true)
  },
  methods: {
    ...mapMutations(["CLOSE_MOBILEMENU", "collapseMainMenu"]),
    checkModulePermissions(module) {
      if (module.length === 0) return true
      if (this.getIsTenantSuperuser) return true
      if (module.washlink && !this.getPOSSystem) return false
      // We should check to see if the user has those module permissions
      return this.getAvailableModules.includes(module)

      // if(module.includes("washlink"))
      // {
      //   console.log("test")
      //   switch (this.getPOSSystem) {
      //     case "":
      //       hasPermissions = false;
      //       break;
      //     case "washlink":
      //       hasPermissions = true;
      //       break;
      //     default:
      //       hasPermissions = false;
      //       break;
      //   }
      // }

      // if(!hasPermissions)
      // {
      //   //If HasPermissions isnt set. lets check it against standalone.
      //   if(module.includes("standalone_chemical")) hasPermissions = this.getPermissionSet.is_chemical_only;
      // }
      // return hasPermissions;
    },
    async collapse() {
      this.collapseMainMenu(!this.mainMenuCollapsed)
      await this.$nextTick()
    },
    routeToReleasesPage() {
      this.$router.push('/Releases')
      this.CLOSE_MOBILEMENU()
    },
    checkTabBack(e) {
      this.tabBack = e.key === "Tab" && e.shiftKey
    },
    handleTab(e) {
      if (this.screen.lg || !this.$refs.sidemenu || this.mobileSubMenuOpen) return
      const tabbedInsideSidemenu = e.target === this.$refs.sidemenu
        || this.$refs.sidemenu.contains(e.target)
      if (!tabbedInsideSidemenu) {
        // redirect to last button if tabbing back
        if (this.tabBack && this.$refs.sidemenu?.querySelector("button")) this.$refs.sidemenu.querySelectorAll("button")[this.$refs.sidemenu.querySelectorAll("button").length - 1].focus()
        // redirect to first button button
        else this.$refs.sidemenu.querySelector("button").focus()
      }
    }
  },
}
</script>

<style scoped>
/* Mobile greeting */
.sidebar-mobile-greeting {
  display: block;
  text-align: left;
  font-weight: 700;
  color: #ffffff;
  font-size: 1.125rem;
  padding: 2rem 1.5rem 1.5rem;
  position: sticky;
  top: 0;
  background: rgba(58, 85, 158, 0.92);
  backdrop-filter: blur(12px);
  z-index: 1;
}
@media screen and (min-width: 1024px) {
  .sidebar-mobile-greeting {
    display: none;
  }
}

/* Organization divider */
.sidebar-divider {
  width: 100%;
  padding: 0.75rem 1rem 0.25rem;
}

.sidebar-divider__label {
  font-size: 0.5625rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  text-align: left;
  padding-left: 0.75rem;
  user-select: none;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 0.75rem;
}

/* Footer (version + collapse) */
.sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.625rem;
  width: 100%;
}

.sidebar-footer__version {
  font-size: 0.6875rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.571);
  cursor: pointer;
  transition: color 0.2s ease;
  padding-left: 0.5rem;
  text-decoration: none;
}
.sidebar-footer__version:hover {
  color: rgba(255, 255, 255, 0.7);
}

.sidebar-footer__collapse {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar-footer__collapse:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.sidebar-footer__collapse-icon {
  font-size: 0.625rem;
}

/* ── Sidebar (dark mode) ────────────────────────── */
[data-theme="dark"] #sideBarScoll {
  background: linear-gradient(180deg, rgba(11, 26, 44, 0.97) 0%, rgba(8, 14, 24, 0.97) 100%);
  backdrop-filter: blur(8px);
}

[data-theme="dark"] .sidebar-mobile-greeting {
  background: rgba(11, 26, 44, 0);
  backdrop-filter: none;
}

[data-theme="dark"] .sidebar-divider__label {
  border-top-color: rgba(255, 255, 255, 0.06);
}

[data-theme="dark"] .sidebar-btn__notif-dot {
  box-shadow: 0 0 0 2px rgba(5, 10, 16, 0.97);
}

[data-theme="dark"] .sidebar-footer__collapse {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.35);
}

[data-theme="dark"] .sidebar-footer__collapse:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}
</style>